import { toast } from 'react-hot-toast';
import { Icon } from '../../components/Icon';

type NotificationType = 'error' | 'warning' | 'success';

type NotificationProps = {
  message: string;
  button?: {
    text: string;
    onClick: () => void;
  };
  type?: NotificationType;
  id?: string;
};

export const Notification = ({
  button,
  message,
  type,
  id,
}: NotificationProps): string => {
  const colors: Record<NotificationType, string> = {
    error: 'bg-red-50 text-red-200',
    warning: 'bg-yellow-50 text-yellow-200',
    success: 'bg-green-50 text-green-300',
  };
  const bg = type ? colors[type] : 'bg-grey-100 text-grey-700';

  const icon: Record<NotificationType, 'Warning' | 'CheckFilled'> = {
    error: 'Warning',
    warning: 'Warning',
    success: 'CheckFilled',
  };

  const usedIcon = type ? icon[type] : null;

  return toast.custom(
    (currentToast) => (
      <div
        className={`max-w-622px pointer-events-auto w-[600px] overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5 ${bg}`}
      >
        <div className="p-2">
          <div className="flex items-center">
            <div className="flex w-0 flex-1 justify-between">
              {usedIcon && (
                <span className="inline-block h-4 w-4">
                  <Icon name={usedIcon} inline />
                </span>
              )}
              <p className="w-0 flex-1 text-center text-sm">{message}</p>
              {button ? (
                <button
                  className="ml-3 flex-shrink-0 rounded-md bg-transparent text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  onClick={() => {
                    if (button.onClick) {
                      button.onClick();
                    }
                    toast.remove(currentToast.id);
                  }}
                >
                  {button.text}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    ),
    {
      id,
    },
  );
};
